import React, { Component } from 'react'
import { HashRouter as Router, Switch, Route, Link, withRouter } from 'react-router-dom';

import getTT from 'getTT';
import routerCfg from 'routerCfg';
import request from 'request';

import Loading from 'ui-loading';
import Err from 'ui-error';

import MonthlyFeeList from './monthlyFeeList'
import UnpayList from './unpayList'
import InstallFeeList from './installFeeList'
import ServiceFeeList from './serviceFeeList'
import PreOrderBill from './PreOrderBill'
import PostOrderBill from './PostOrderBill'
import MonthlyBill from './MonthlyBill'

import { Tabs, Menu, Badge, Layout } from 'antd';
import styles from './style.scss?__local'
import UnPayBill from './UnPayBill';

const { Sider, Content} = Layout;

const menuList = [
  {
    text: '直接付费商品账单',
    path: '/fee/preorder-bill',
    comp: PreOrderBill,
  },
  {
    text: '礼物收益商品账单',
    path: '/fee/postorder-bill',
    comp: PostOrderBill,
  },
  {
    text: '本月累计使用明细',
    path: '/fee/monthly-bill',
    comp: MonthlyBill,
  },
  {
    text: '本月费用清单',
    path: '/fee/monthly-fee',
    comp: MonthlyFeeList,
  },
  /*
   * {
   *   text: '安装费清单',
   *   path: 'installFeeList',
   *   comp: InstallFeeList
   * },
   */
  {
    text: '服务费清单',
    path: '/fee/service-bill',
    comp: ServiceFeeList,
  },
  {
    text: '补缴清单',
    path: '/fee/unpay-bill',
    comp: UnPayBill,
  },
]

// import MonthlyBill from './MonthlyBill';

class Fee extends Component {
  constructor(props) {
    super(props);

    let initialPath = menuList[0].path

    if (props.location.pathname === '/fee') {
      props.history.push(menuList[0].path)
    } else {
      initialPath = props.location.pathname.toLowerCase()
    }

    this.state = {
      isLoading: true,
      errText: '',
      selectedMenuKey: initialPath,
      reddotList: [],
    }


    this.switchMenu = this.switchMenu.bind(this)
  }

  componentDidMount() {
    getTT(TT => {
      // 有时不知道为什么拿不到 TT 的，所以这里做下容错
      if (TT) {
        TT.getUserInfo(userInfo => {
          if (userInfo.uid == 0) {
            TT.login.login()
            TT.login.on('loginClose', () => {
              this.setState({
                errText: '未登录',
              })
            })
          } else {
            this.getFeeList();
          }
        })
      } else {
        this.setState({
          errText: '未登录',
        })
      }
    })
  }

  getFeeList() {
    this.setState({
      isLoading: false,
    })
  }

  getUnpayList() {
    const { reddotList } = this.state;

    request({
      url: request.api.getUnpayList,
      type: 'GET',
    })
      .done(res => {
        if (res.serviceBacks && res.serviceBacks.length) {
          reddotList[0] = true;

          this.setState({
            reddotList,
          })
        }
      })
  }

  switchMenu({key}) {
    const idx = menuList.findIndex(item => item.path == key);
    const { reddotList } = this.state;

    reddotList[idx] = false;

    this.setState({
      selectedMenuKey: key,
      reddotList,
    })

  }

  render() {
    const { isLoading, errText, selectedMenuKey, reddotList } = this.state;

    return (
      <div>
        {
          (isLoading && !errText) ? <Loading></Loading> : ''
        }

        {
          errText && <Err err={`获取数据失败：${errText}`} ></Err>
        }

        {
          (!isLoading && !errText)
            ?
            <Layout className={styles.layout_wrapper}>
              <Sider theme='light' className={styles.sider}>
                {
                  <Menu mode='inline' onClick={this.switchMenu} selectedKeys={[selectedMenuKey]}>
                    {
                      menuList.map((item, idx) => (
                        <Menu.Item key={item.path}>
                          <Link to={item.path}>{ item.text }</Link>
                          {
                            (reddotList[idx] && selectedMenuKey != item.path) ?
                              <Badge dot={true}></Badge>
                              :
                              ''
                          }
                        </Menu.Item>
                      ))
                    }
                  </Menu>
                }
              </Sider>

              <Content>
                <Switch>
                  {
                    menuList.map(item => <Route extact path={item.path} component={item.comp} key={item.path} />)
                  }
                </Switch>
              </Content>
            </Layout>
            :
            ''
        }
      </div>
    )
  }
}

export default withRouter(Fee)
